<template>
    <div class="flex items-baseline gap-2 choice-draggable">
        <span class="text-slate-500 cursor-move choice-move">
            <font-awesome-icon widthAuto :icon="faGripDotsVertical" />
        </span>
        <div class="w-full">
            <vx-input ref="inputRef" size="lg" placeholder="Choice" :modelValue="props.modelValue"
                :error="displayFirstError(validation.$errors)"
                @keyup.prevent.enter="emit('add')"
                @keydown.backspace="removeOnBackspace"
                @update:modelValue="emit('update:modelValue', $event)" :maxlength="80"></vx-input>
        </div>
        <vx-button @click.prevent="emit('remove')" data-test="remove-choice" aria-label="Remove choice" color="muted">
            <font-awesome-icon widthAuto :icon="faTrash" />
        </vx-button>
    </div>
</template>
<script setup>
import { faTrash, faGripDotsVertical } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { VxInput, VxButton } from '@voxie/frontend-components';
import useVuelidate from '@vuelidate/core';
import { required, maxLength, helpers} from '@vuelidate/validators';
import { computed, ref } from 'vue';
import { alphanumericDashUnderscoreSpace, displayFirstError } from '~/utils/validation';

const props = defineProps({
    modelValue: {
        type: String,
        default: '',
    },
    list: {
        type: Array,
        default: () => ([]),
    }
});

const emit = defineEmits(['update:modelValue', 'add', 'remove']);

const validation = useVuelidate({
    required,
    maxLength: maxLength(80),
    format: alphanumericDashUnderscoreSpace,
    distinct: helpers.withMessage(({ $model }) => `Choice ${$model} has already been added`, (value) => props.list.filter((choice) => choice.value === value).length < 2),
}, computed(() => props.modelValue))

const inputRef = ref();

const removeOnBackspace = (event) => {
    if (!props.modelValue.length) {
        event.preventDefault();
        emit('remove')
    }
}

defineExpose({
    focus: () => inputRef.value?.field?.focus?.(),
});
</script>
